export enum IkeLogType {
	SERVER = 'server',
	CLI = 'cli',
	BOT = 'bot',
	FUNCTION = 'function',
	CONSOLE = 'console',
	CLIENT = 'client',
}
